import { HTTP } from "@/http-common";

import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";

const state = {
  Commissions: [],
  run: {
    runId: null,
    runType: 1
  },
  runs: []
};

const actions = {
  uploadSupplierFile({ dispatch }, formData) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post("Commissions/UploadSupplierFile", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      response
        .then(function(data) {
          var resultData = data.data;
          resolve(resultData);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in uploading file : " + err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject();
        });
    });
  },

  resetCommissions({ commit }) {
    commit("setCommissions", []);
  },
  setRun({ state, commit }, selection) {
    let run = state.runs.filter(
      x => x.runId == selection.runId && x.runType == selection.runType
    );
    if (run.length === 1) commit("setRunID", run);
  },
  getCommissions({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      dispatch("message/reset", null, {
        root: true
      });

      var response = HTTP.post("OMS/ListCommissionSummaries", state.run);
      response
        .then(function(data) {
          var resultData = data.data;
          resolve(resultData);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting Commissionss : " + err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject();
        });
    });
  },
  addCommissions({ state, commit }) {
    commit("setCommissions", state.Commissions);
  },
  updateSummary({ dispatch }, summary) {
    return new Promise((resolve, reject) => {
      HTTP.post(`Commissions/UpdateSummary`, summary)
        .then(data => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Summary Saved",
              httpStatus: 200
            }),
            {
              root: true
            }
          );
          if (data.status == 200) resolve(data.data);
          else resolve([]);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject(err);
        });
    });
  },

  downloadCommissions({ dispatch }, commissionsQuery) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        "DealerPortal/DownloadCommissionsPDF",
        commissionsQuery,
        {
          responseType: "arraybuffer"
        }
      );
      response
        .then(function(data) {
          if (data.status == 204) {
            dispatch(
              "message/setMessage",
              new httpError({
                message: "Report not found",
                httpStatus: 500
              }),
              {
                root: true
              }
            );
            reject();
            return;
          }
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Agent-${JSON.parse(data.config["data"]).dealerID}Commissions.pdf`
          );
          document.body.appendChild(link);
          link.click();
          resolve();
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting Commissionss : " + err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject();
        });
    });
  },
  emailCommissions({ dispatch }, commissionsQuery) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        "DealerPortal/EmailCommissionsPDF",
        commissionsQuery
      );
      response
        .then(function(data) {
          if (data.status == 204) {
            dispatch(
              "message/setMessage",
              new httpError({
                message: "Report not found",
                httpStatus: 500
              }),
              {
                root: true
              }
            );
            reject();
            return;
          }
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Email has been sent",
              httpStatus: 200
            }),
            {
              root: true
            }
          );
          resolve();
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting Commissionss : " + err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject();
        });
    });
  },
  CreateReports({ dispatch }, request) {
    return new Promise((resolve, reject) => {
      if (!request.runId) reject("no runID provided");

      HTTP.get(`Commissions/SaveAllReports/${request.runId}/${request.runType}`)
        .then(data => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Reports Created",
              httpStatus: 200
            }),
            {
              root: true
            }
          );
          resolve(data.data);
        })
        .catch(err => {
          if (
            (err.response.data.myob &&
              err.response.data.myob.length > 0) &&
            err.response.data.myob.missingSuppliers.length > 0
          ) {
            dispatch(
              "message/setMessage",
              new httpError({
                message: `Missing suppliers detected : (${err.response.data.myob.missingSuppliers.length})`,
                httpStatus: 500
              }),
              {
                root: true
              }
            );
          } else
            dispatch(
              "message/setMessage",
              new httpError({
                message: err.message,
                httpStatus: 500
              }),
              {
                root: true
              }
            );
          reject(err.response.data.myob);
        });
    });
  },
  ImportStatement({ dispatch }, runId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`Commissions/ImportStatementData/${runId}`)
        .then(data => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Payments Uploaded",
              httpStatus: 200
            }),
            {
              root: true
            }
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject(err);
        });
    });
  },
  ImportPayments({ dispatch }, payments) {
    return new Promise((resolve, reject) => {
      HTTP.post(`Commissions/UploadFiles/${payments.runId}`, payments.files, {
        headers: {
          "Content-Disposition": "multipart/form-data"
        }
      })
        .then(data => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Payments Uploaded",
              httpStatus: 200
            }),
            {
              root: true
            }
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject(err);
        });
    });
  },
  getCommissionRuns({ commit, dispatch, state }, runType) {
    if (runType == undefined) runType = 1;
    return new Promise((resolve, reject) => {
      commit("setRunType", runType);
      HTTP.get(`Commissions/GetCommissionRuns/${state.runType}`)
        .then(function(data) {
          var resultData = data.data.commissionRuns;
          commit("setRuns", resultData);
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting Commissions runs : " + err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject();
        });
    });
  },
  ListInitialSummary({ dispatch }, request) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        `Commissions/InitialSummary/${request.runId}/${request.runType}/false`
      )
        .then(function(data) {
          var resultData = data.data;

          resolve(resultData);
        })
        .catch(err => {
          if (
            (err.response.data.myob &&
              err.response.data.myob &&
              err.response.data.myob.length > 0) ||
            err.response.data.myob.missingSuppliers.length > 0
          ) {
            dispatch(
              "message/setMessage",
              new httpError({
                message: `Missing suppliers detected : (${err.response.data.myob.missingSuppliers.length})`,
                httpStatus: 500
              }),
              {
                root: true
              }
            );
          } else {
            dispatch(
              "message/setMessage",
              new httpError({
                message: "Error in getting Commissions runs : " + err.message,
                httpStatus: 500
              }),
              {
                root: true
              }
            );
          }
          reject(err);
        });
    });
  },
  CreateInitials({ dispatch }, run) {
    return new Promise((resolve, reject) => {
      HTTP.get("Commissions/FindMissingRatePlans")
        .then(data => {
          if (data.data && data.data.length > 0) {
            dispatch(
              "message/setMessage",
              new httpError({
                message: `There are missing rate plans`,
                httpStatus: 500
              }),
              {
                root: true
              }
            );
            resolve({
              type: "missingPlans",
              data: data.data
            });
          } else {
            HTTP.post(
              `Commissions/Create${run.runType == 1 ? "Initials" : "Royalty"}/${
                run.runId
              }`
            )
              .then(data => {
                dispatch(
                  "message/setMessage",
                  new httpError({
                    message: `${
                      run.runType == 1 ? "Initials" : "Royalty"
                    } created`,
                    httpStatus: 200
                  }),
                  {
                    root: true
                  }
                );
                resolve({
                  type: "comms",
                  data: data.data
                });
              })
              .catch(err => {
                dispatch(
                  "message/setMessage",
                  new httpError({
                    message: err.message,
                    httpStatus: 500
                  }),
                  {
                    root: true
                  }
                );
                reject(err);
              });
          }
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  ListInitialDetails({ dispatch }, request) {
    return new Promise((resolve, reject) => {
      HTTP.get(`Commissions/InitialDetails/${request.runId}/${request.runType}`)
        .then(function(data) {
          var resultData = data.data;
          resolve(resultData);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Error in getting Commissions runs : " + err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject();
        });
    });
  },
  CreateSummaryReport({ dispatch }, run) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        `Commissions/InitialSummary/${run.runId}/${run.runType}/true`,
        {},
        {
          responseType: "blob"
        }
      )
        .then(data => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: "Initial summary created",
              httpStatus: 200
            }),
            {
              root: true
            }
          );
          resolve(data);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject(err);
        });
    });
  },
  DownloadReports({ dispatch }, val) {
    return new Promise((resolve, reject) => {
      HTTP.post(`Commissions/DownloadZip`, val, {
        responseType: "blob" // important
      })
        .then(response => {
          resolve(response);
        })
        .catch(async error => {
          let statusCode = error.response.status;
          let responseObj = await error.response.data.text();
          dispatch(
            "message/setMessage",
            new httpError({
              message: responseObj,
              httpStatus: statusCode
            }),
            {
              root: true
            }
          );
          reject(error);
        });
    });
  },
  CommissionsRequest({ dispatch }, query) {
    return new Promise((resolve, reject) => {
      HTTP[query.method](query.url, query.body)
        .then(data => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: query.message,
              httpStatus: 200
            }),
            {
              root: true
            }
          );
          if (data.status == 200) resolve(data.data);
          else resolve([]);
        })
        .catch(err => {
          dispatch(
            "message/setMessage",
            new httpError({
              message: err.message,
              httpStatus: 500
            }),
            {
              root: true
            }
          );
          reject(err);
        });
    });
  }
};

const mutations = {
  setCommissions(state, Commissions) {
    state.Commissions = Commissions;
  },
  setRunID(state, run) {
    Object.assign(state.run, run[0]);
  },
  setRuns(state, runs) {
    state.runs = runs;
    state.runs.sort((a, b) => {
      return b.runId - a.runId;
    });
  },
  setRunType(state, runType) {
    state.runType = runType;
  },
  updateField
};

const getters = {
  run: state => state.run,
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
